<template>
    <main class="app-content">
        <div class="app-title">
            <div>
                <h1><i class="fa fa-dashboard"></i> {{ $t('reportCall') }}</h1>
            </div>
            <ul class="app-breadcrumb breadcrumb">
                <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
                <li class="breadcrumb-item"><router-link to="/report/call">{{ $t('reportCall') }}</router-link></li>
            </ul>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="tile">
                    <div class="form-inline">
                        <client-select :model="filterFormModel" attribute="client" @input="load" class="mr-1"></client-select>
                        <form-select :model="filterFormModel" attribute="group" class="mr-1" :options="[
                            {value:'day',text:$t('byDays')},
                            {value:'user',text:$t('byStaffs')},
                            {value:'group',text:$t('byGroups')},
                            ]">
                        </form-select>
                        <form-select :model="filterFormModel" attribute="direction" class="mr-1" :options="[
                            {value:null,text:$t('all')},
                            {value:'inbound',text:$t('inbound')},
                            {value:'outbound',text:$t('outbound')},
                            {value:'local',text:$t('local')},
                            ]">
                        </form-select>
                        <time-range-picker :model="filterFormModel" :label="$t('time')" :defaultShortcut="3" class="mr-1"></time-range-picker>
                        <button @click="load" class="btn btn-primary mr-1">{{$t('search')}}</button>
<!--                        <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>-->
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="tile shadow">
                    <h3 class="tile-title">{{ $t('calls') }}</h3>
                    <apexchart :height="300" :options="chartOptions" :series="callChartData"></apexchart>
                </div>
            </div>
            <div class="col-md-6">
                <div class="tile shadow">
                    <h3 class="tile-title">{{ $t('duration') }}</h3>
                    <apexchart :height="300" :options="chartOptions" :series="durationChartData"></apexchart>
                </div>
            </div>
            <div class="col-12">
                <div class="tile">
                    <div class="table-responsive c-template-table">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th class="text-center">{{ $t('totalCount') }}</th>
                                    <th class="text-center">{{ $t('successCount') }}</th>
                                    <th class="text-center">{{ $t('busyCount') }}</th>
                                    <th class="text-center">{{ $t('rejectedCount') }}</th>
                                    <th class="text-center">{{ $t('invalidNumberCount') }}</th>
                                    <th class="text-center">{{ $t('networkBusyCount') }}</th>
                                    <th class="text-center">{{ $t('agentNetworkFailCount') }}</th>
                                    <th class="text-center">{{ $t('othersCount') }}</th>
                                    <th class="text-center">{{ $t('talkingTime') }}</th>
                                    <th class="text-center">{{ $t('waitingTime') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="bg-success">
                                    <td><b class="text-uppercase">{{ $t('totals') }}</b></td>
                                    <td class="text-center"><span class="text-blue">{{ sum.total }}</span></td>
                                    <td class="text-center"><span class="text-blue">{{ sum.success }}</span></td>
                                    <td class="text-center"><span class="text-blue">{{ sum.busy }}</span></td>
                                    <td class="text-center"><span class="text-blue">{{ sum.rejected }}</span></td>
                                    <td class="text-center"><span class="text-blue">{{ sum.invalidNumber }}</span></td>
                                    <td class="text-center"><span class="text-blue">{{ sum.networkBusy }}</span></td>
                                    <td class="text-center"><span class="text-blue">{{ sum.agentNetworkFail }}</span></td>
                                    <td class="text-center"><span class="text-blue">{{ sum.other }}</span></td>
                                    <td class="text-center">{{ sum.billDuration | callDuration }}</td>
                                    <td class="text-center">{{ sum.duration - sum.billDuration | callDuration }}</td>
                                </tr>
                                <tr class="bg-warning">
                                    <td><b class="text-uppercase">{{ $t('average') }}</b></td>
                                    <td class="text-center"><span class="text-blue">{{ avg.total }}</span></td>
                                    <td class="text-center"><span class="text-blue">{{ avg.success }}</span></td>
                                    <td class="text-center"><span class="text-blue">{{ avg.busy }}</span></td>
                                    <td class="text-center"><span class="text-blue">{{ avg.rejected }}</span></td>
                                    <td class="text-center"><span class="text-blue">{{ avg.invalidNumber }}</span></td>
                                    <td class="text-center"><span class="text-blue">{{ avg.networkBusy }}</span></td>
                                    <td class="text-center"><span class="text-blue">{{ avg.agentNetworkFail }}</span></td>
                                    <td class="text-center"><span class="text-blue">{{ avg.other }}</span></td>
                                    <td class="text-center">{{ avg.billDuration | callDuration }}</td>
                                    <td class="text-center">{{ avg.duration - avg.billDuration | callDuration }}</td>
                                </tr>
                                <tr :key="index" v-for="(item, index) in data">
                                    <td style="min-width: 200px"><b>{{ label(item) }}</b></td>
                                    <td class="text-center"><span class="text-blue">{{ item.total }}</span></td>
                                    <td class="text-center"><span class="text-blue">{{ item.success }}</span></td>
                                    <td class="text-center"><span class="text-blue">{{ item.busy }}</span></td>
                                    <td class="text-center"><span class="text-blue">{{ item.rejected }}</span></td>
                                    <td class="text-center"><span class="text-blue">{{ item.invalidNumber }}</span></td>
                                    <td class="text-center"><span class="text-blue">{{ item.networkBusy }}</span></td>
                                    <td class="text-center"><span class="text-blue">{{ item.agentNetworkFail }}</span></td>
                                    <td class="text-center"><span class="text-blue">{{ item.other }}</span></td>
                                    <td class="text-center">{{ item.billDuration | callDuration }}</td>
                                    <td class="text-center">{{ item.duration - item.billDuration | callDuration }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
    import moment from 'moment';
    import TimeRangePicker from "../../components/TimeRangePicker";
    import VueApexCharts from 'vue-apexcharts';
    import ClientSelect from "../../components/ClientSelect";

    export default {
        components: {
            ClientSelect,
            TimeRangePicker,
            'apexchart': VueApexCharts
        },
        data() {
            return {
                filterFormModel: {
                    group: 'day',
                    direction: null,
                    client: null
                },
                loading: true,
                data: [],
                sum: {},
                avg: {},
                chartOptions: {},
                callChartData: [],
                durationChartData: []
            }
        },
        methods: {
            load() {
                this.loading = true;
                this.filterFormModel.to = moment(this.filterFormModel.to, 'x').endOf('day').format('x');
                this.$service.get('/report/call', {
                    params: this.filterFormModel
                }).then(response => {
                    this.data = response.data;
                    this.sum = {};
                    this.avg = {};
                    this.data.forEach(item => {
                        item.other = item.total - (item.success + item.busy + item.rejected + item.invalidNumber + item.networkBusy + item.agentNetworkFail);
                        for (let key in item) {
                            if (!this.sum[key]) {
                                this.sum[key] = 0;
                            }
                            this.sum[key] += item[key];
                        }
                    });
                    for (let key in this.sum) {
                        this.avg[key] = Math.round(this.sum[key] / this.data.length);
                    }
                    this.chartOptions = {
                        xaxis: {
                            categories: this.data.map(d => this.label(d)).slice(0, 99).reverse(),
                            labels: {
                                rotate: 0
                            },
                            tooltip: {
                                enabled: false,
                            }
                        },
                        chart: {
                            zoom: {
                                enabled: false
                            },
                            type: this.filterFormModel.group === 'day' ? 'line' : 'bar'
                        }
                    };
                    this.callChartData = [
                        {
                            name: this.$t('totalCount'),
                            data: this.data.map(d => d.total).slice(0, 99).reverse(),
                        },
                        {
                            name: this.$t('successCount'),
                            data: this.data.map(d => d.success).slice(0, 99).reverse(),
                        },
                        {
                            name: this.$t('failureCount'),
                            data: this.data.map(d => d.total - d.success).slice(0, 99).reverse(),
                        },
                    ];
                    this.durationChartData = [
                        {
                            name: this.$t('duration'),
                            data: this.data.map(d => d.duration).slice(0, 99).reverse(),
                        },
                        {
                            name: this.$t('talkingTime'),
                            data: this.data.map(d => d.billDuration).slice(0, 99).reverse(),
                        },
                        {
                            name: this.$t('waitingTime'),
                            data: this.data.map(d => d.duration - d.billDuration).slice(0, 99).reverse(),
                        },
                    ];
                }).finally(() => {
                    this.loading = false;
                });
            },
            label(item) {
                if (item.label) {
                    return item.label;
                }
                if (!isNaN(item._id)) {
                    return moment(this.filterFormModel.from + item._id, 'x').format('ll');
                }
            }
        },
        mounted() {
            this.load();
        },
        i18n: {
            messages: {
                en: {
                    reportCall: 'Call report',
                    byDays: 'By days',
                    byStaffs: 'By staffs',
                    byGroups: 'By groups',
                    calls: 'Calls',
                    duration: 'Duration',
                    totalCount: 'Total',
                    successCount: 'Connected',
                    busyCount: 'Busy',
                    rejectedCount: 'Rejected',
                    invalidNumberCount: 'Invalid number',
                    networkBusyCount: 'Network busy',
                    agentNetworkFailCount: 'Agent network fail',
                    failureCount: 'Fail to connect',
                    othersCount: 'Others',
                    talkingTime: 'Talking time',
                    waitingTime: 'Waiting time',
                    totals: 'Total',
                    average: 'Average'
                },
                vi: {
                    reportCall: 'Báo cáo cuộc gọi',
                    byDays: 'Theo ngày',
                    byStaffs: 'Theo nhân viên',
                    byGroups: 'Theo nhóm',
                    calls: 'Cuộc gọi',
                    duration: 'Thời lượng',
                    totalCount: 'Tổng',
                    successCount: 'Kết nối thành công',
                    busyCount: 'Máy bận',
                    rejectedCount: 'Từ chối',
                    invalidNumberCount: 'Sai số',
                    networkBusyCount: 'Mạng bận',
                    agentNetworkFailCount: 'Lỗi mạng của agent',
                    failureCount: 'Kết nối thất bại',
                    othersCount: 'Khác',
                    talkingTime: 'Thời gian đàm thoại',
                    waitingTime: 'Thời gian chờ',
                    totals: 'Total',
                    average: 'Average'
                }
            }
        }
    };
</script>